'use strict';

require('../modules/forms/forms');
require('../models/mountains/routeTypes');
require('../models/mountains/routeComplexities');
require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.mountainRouteForm', [
	'dekky.forms',
	'far.models.mountains.routeTypes',
	'far.models.mountains.routeComplexities',
	'far.helpers.showModalMessage'
])
.service('mountainRouteForm', function(form, autocomplete, mountainRouteTypes, mountainRouteComplexities, fileUploadFilters, showModalMessage) {
	var mountainRouteModel = form('mountainRouteModel');

	mountainRouteModel
		.addField('name', null, {
			validators: { required: true },
			options: { placeholder: 'Название' }
		})
		.addField('description', 'textarea', {
			options: {
                redactor: true,
				placeholder: 'Ваше описание'
			}
		})
		.addField('num', null, {
			options: { placeholder: 'Номер' }
		})
		.addField('route_status', 'checkbox')
		.addField('slides', 'hidden')
		.addField('documents', 'hidden')
		.addField('first_ascent_year', null, {
			validators: { required: false },
			options: { placeholder: 'Год прохождения', maxlength: 4, numericOnly: '' }
		})
        .addField('camp', 'uiSelect', {
            validators: {
                required: false
            },
            options: {
                onSelect: 'field.uiSelectOptions.onSelect($item, $model)'
            },
            uiSelectOptions: {
                matchTitle: '{{ $select.selected.name }} ',
                choicesTitle: '{{ item.name }}',
                match: {
                    placeholder: 'Альплагерь',
                    allowClear: true
                },
                choices: {
                    repeat: 'item in field.items track by item.id',
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Camp", "camp")',
                    refreshDelay: 0
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('camp'))

		.addField('mountain_peak', 'mountainPeakSelect')

		.addField('routeType', 'selectObject', {
			validators: { required: true },
			ngOptions: 'item as item.name for item in field.items track by item.id',
			label_before: 'Характер маршрута:',
			label_before_class: 'form__comment'
		}, mountainRouteTypes.list)
		.addField('routeComplexity', 'selectObject', {
			validators: { required: true },
			ngOptions: 'item as item.name for item in field.items track by item.id',
			label_before: 'Категория сложности:',
			label_before_class: 'form__comment'
		}, mountainRouteComplexities.list)
        .addField('routeUser', 'userSelect', {
          
            uiSelectOptions: {
                match: {
                    placeholder: 'Имя и фамилия руководителя'
                },
                choices: {
                    refresh: 'field.uiSelectOptions.refreshAutoComplete($select.search, "Users", "users")'
                },
                refreshAutoComplete: autocomplete.refreshAutoComplete
            }
        }, autocomplete.get('users'))
        .addField('newRouteUserFirstName', null, {
			options: {placeholder: 'Имя  руководителя'},
		})
		.addField('newRouteUserLastName', null, {
			options: {placeholder: 'Фaмилия руководителя'},
		})
		.addField('slidesFiles', 'imageUpload', {
			validators: { required: true },
			label: 'Загрузить изображение',
			uploader: {
				url: Routing.generate('api_upload_post_image'),
				filters: [
					fileUploadFilters.fileSize()
				],
				autoUpload: true,
				removeAfterUpload: true,
				onWhenAddingFileFailed: function(item, filter) {
					var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
					showModalMessage(message);
				}
			}
		})
		.addField('documentsFiles', 'fileUpload', {
			validators: { required: true },
			label: 'Загрузить документ',
			uploader: {
				url: Routing.generate('api_upload_post_file'),
				autoUpload: true,
				filters: [
					fileUploadFilters.fileSize(),
					fileUploadFilters.fileType()
				],
				// onSuccessItem: function (item, response) {
				// 	item.serverData = response;
				// },
				onWhenAddingFileFailed: function(item, filter) {
					var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
					showModalMessage(message);
				}
			}
		});

	return mountainRouteModel;
});